const Meter = (props) => {
    let { title } = props;
    let { value = 0, minValue = 0, maxValue = 100, size = 170, strokeWidth = 10, fontSize } = props;

    let center = size / 2;
    let r = center - strokeWidth;
    let c = 2 * r * Math.PI;
    let a = c * (270 / 360);
    let percentage = (value - minValue) / (maxValue - minValue);
    let offset = c - percentage * a;

    const valueFontSize = fontSize || Math.max(12, Math.round(size * 0.14));
    const titleFontSize = fontSize ? Math.round(fontSize * 0.83) : Math.max(10, Math.round(size * 0.12));

    const getColor = (value) => {
        if (value <= 20) return "#ef4438";
        else if (value <= 40) return "#F1592A";
        else if (value <= 60) return "#F4BC1A";
        else if (value <= 80) return "#4ac4bf";
        else return "#31aba6";
    };
    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" strokeWidth={strokeWidth} role="img" aria-label={`${title ? title + ": " : ""}${Math.round(value)} out of ${maxValue}`}>
                <circle role="presentation" cx={center} cy={center} r={r} stroke={"#31aba6"} strokeOpacity={0.2} strokeDasharray={`${a} ${c}`} strokeLinecap="round" transform={`rotate(135 ${center} ${center})`} />
                <circle role="presentation" cx={center} cy={center} r={r} stroke={getColor(value)} strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round" transform={`rotate(135 ${center} ${center})`} />
                <text role="presentation" x={center} y={center + valueFontSize * 0.4} fontWeight="bold" fontFamily="ui-rounded, system-ui" fontSize={valueFontSize} textAnchor="middle" fill={getColor(value)}>
                    {Math.round(value)}
                </text>
                {title && (
                    <text role="presentation" x={center} y={center - size * 0.15} fontFamily="ui-rounded, system-ui" fontSize={titleFontSize} textAnchor="middle" fill={getColor(value)} fillOpacity={0.85}>
                        {title}
                    </text>
                )}
            </svg>
        </div>
    );
};

export default Meter;
